import { tips } from "@/mocks/navData";

const ICONS = ["ri-focus-2-line", "ri-price-tag-3-line", "ri-bookmark-3-line"];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-[#f1e6d1]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
            <i className="ri-road-map-line text-sm"></i>
            怎么上手
          </span>
          <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
            找瓜三步，一分钟就学会
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-[#6b5d48]">
            没有复杂设置，顺着下面三步走，第一次来也能马上用顺。
          </p>
        </div>

        <div className="relative mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* connecting dashed line */}
          <div className="pointer-events-none absolute left-[16%] right-[16%] top-10 hidden border-t-2 border-dashed border-[#d9b57e]/70 md:block"></div>

          {tips.map((tip, i) => (
            <div
              key={tip.no}
              className="relative rounded-2xl border border-[#ead9bd] bg-[#fffdf8] p-6 text-center"
            >
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#f0e3cd]">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#e4562b] text-white">
                  <i className={`${ICONS[i] ?? "ri-circle-line"} text-xl`}></i>
                </span>
              </div>
              <p className="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-[#b0843f]">
                第 {tip.no} 步
              </p>
              <h3 className="mt-2 text-lg font-bold text-[#2a2016]">{tip.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#8a7c64]">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}